import type { AppRouteModule } from '@/router/types';

import { LAYOUT } from '@/router/constant';
import { RoleEnum } from '@/enums/roleEnum';

const BasicConfig: AppRouteModule = {
  path: '/basicConfig',
  name: 'BasicConfig',
  identify: 'basicConfig',
  component: LAYOUT,
  redirect: '/basicConfig/storeConfig',
  meta: {
    icon: 'ri:list-settings-line',
    title: '基础配置',
    orderNo: 1,
    roles: [RoleEnum.OFFLINE],
  },
  children: [
    {
      path: 'storeConfig',
      name: 'StoreConfig',
      component: () => import('@/views/basicConfig/storeConfig/index.vue'),
      identify: 'storeConfig',
      meta: {
        title: '门店管理',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'storeConfig/add',
      name: 'StoreConfigAdd',
      identify: 'storeConfig',
      component: () => import('@/views/basicConfig/storeConfig/add.vue'),
      meta: {
        title: '新建门店',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/basicConfig/storeConfig',
        roles: [RoleEnum.OFFLINE],
      },
    },
    // {
    //   path: 'regionManage',
    //   name: 'RegionManage',
    //   identify: 'regionManage',
    //   component: () => import('@/views/basicConfig/regionManage/index.vue'),
    //   meta: {
    //     title: '区域管理',
    //   },
    // },
    {
      path: 'resourceManage',
      name: 'ResourceManage',
      identify: 'resourceManage',
      component: () => import('@/views/basicConfig/resourceManage/index.vue'),
      meta: {
        title: '资源管理',
        roles: [RoleEnum.OFFLINE],
      },
    },
    // {
    //   path: 'roleManage',
    //   name: 'RoleManage',
    //   identify: 'roleManage',
    //   component: () => import('@/views/basicConfig/roleManage/index.vue'),
    //   meta: {
    //     title: '角色管理',
    //     roles: [RoleEnum.OFFLINE],
    //   },
    // },
    // {
    //   path: 'roleManage/:type/:id?',
    //   name: 'RoleManageAdd',
    //   identify: 'roleManage',
    //   component: () => import('@/views/basicConfig/roleManage/add.vue'),
    //   meta: {
    //     title: '角色管理-新增',
    //     roles: [RoleEnum.OFFLINE],
    //     hideMenu: true,
    //     hideTab: true,
    //     currentActiveMenu: '/basicConfig/roleManage',
    //   },
    // },
    {
      path: 'employeeManage',
      name: 'EmployeeManage',
      identify: 'employeeManage',
      component: () => import('@/views/basicConfig/employeeManage/index.vue'),
      meta: {
        title: '员工管理',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'employeeManage/add',
      name: 'EmployeeManageAdd',
      identify: 'employeeManage',
      component: () => import('@/views/basicConfig/employeeManage/add.vue'),
      meta: {
        title: '创建员工',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/basicConfig/employeeManage',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'monitorManage',
      name: 'MonitorManage',
      identify: 'monitorManage',
      component: () => import('@/views/basicConfig/monitorManage/index.vue'),
      meta: {
        title: '设备管理',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'monitorManage/:pageType/:id?',
      name: 'MonitorManageAdd',
      identify: 'monitorManage',
      component: () => import('@/views/basicConfig/monitorManage/add.vue'),
      meta: {
        title: '新增设备',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/basicConfig/monitorManage',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'learningMachineManage',
      name: 'LearningMachineManage',
      identify: 'learningMachineManage',
      component: () => import('@/views/basicConfig/learningMachineManage/index.vue'),
      meta: {
        title: '学习机管理',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'scoreInput',
      name: 'ScoreInput',
      identify: 'scoreInput',
      component: () => import('@/views/basicConfig/scoreInput/index.vue'),
      meta: {
        title: '成绩录入',
        roles: [RoleEnum.OFFLINE],
      },
    },
  ],
};

export default BasicConfig;
